(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["hh-base-pack-math"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hh-pack-math')) {
    class HHPackMath extends HTMLElement {
      connectedCallback() {
        const script = this.querySelector('script[type="application/json"]');
        try {
          this.hhMap = script ? JSON.parse(script.textContent) : {};
        } catch (e) {
          this.hhMap = {};
        }
        this.hhVariantId = this.dataset.initialVariantId;
        this.hhQty = this.readQty();
        this.onVariant = (event) => {
          const detail = event.detail || {};
          if (!detail.data || String(detail.data.productId) !== this.dataset.productId) return;
          if (!detail.resource || !detail.resource.id) return;
          this.hhVariantId = String(detail.resource.id);
          // Re-read quantity after the native product form has possibly reset it
          requestAnimationFrame(() => {
            this.hhQty = this.readQty();
            this.renderLine();
          });
        };
        this.onQty = (event) => {
          if (event.detail && event.detail.cartLine) return;
          this.hhQty = this.readQty();
          this.renderLine();
        };
        document.addEventListener('variant:update', this.onVariant);
        document.addEventListener('quantity-selector:update', this.onQty);
        this.renderLine();
      }

      disconnectedCallback() {
        document.removeEventListener('variant:update', this.onVariant);
        document.removeEventListener('quantity-selector:update', this.onQty);
      }

      readQty() {
        const input = document.querySelector('product-form-component input[name="quantity"]');
        const n = input ? parseInt(input.value, 10) : 1;
        return Number.isFinite(n) && n > 0 ? n : 1;
      }

      renderLine() {
        const line = this.querySelector('[data-line]');
        const entry = this.hhMap[this.hhVariantId];
        if (!line || !entry || entry.qty <= 1) {
          this.hidden = true;
          return;
        }
        this.hidden = false;
        if (this.dataset.mode === 'echo') {
          line.textContent = entry.per + ' · ' + entry.qty + ' ' + entry.units + ' per pack';
        } else {
          const packs = this.hhQty;
          const total = packs * entry.qty;
          line.textContent =
            packs + (packs === 1 ? ' pack' : ' packs') + ' × ' + entry.qty + ' = ' + total + ' ' + entry.units;
        }
      }
    }
    customElements.define('hh-pack-math', HHPackMath);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hh-base-variant-picker"] && !Shopify.designMode) return;
  try {
    // HH variant sync — refreshes [data-hh-variant-sync] wrappers from the freshly
  // fetched document on every variant change. Owned by hh-base-variant-picker;
  // consumed by hh-base-dimensions / hh-base-compatibility / hh-base-trust-strip
  // and by the mobile proxy select below (keeps its `selected` server-accurate).
  if (!window.hhVariantSyncBound) {
    window.hhVariantSyncBound = true;
    document.addEventListener('variant:update', (event) => {
      const html = event.detail && event.detail.data && event.detail.data.html;
      if (!html) return;
      document.querySelectorAll('[data-hh-variant-sync]').forEach((el) => {
        const key = el.getAttribute('data-hh-variant-sync');
        const next = html.querySelector('[data-hh-variant-sync="' + key + '"]');
        if (next) el.innerHTML = next.innerHTML;
      });
    });
  }

  // HH mobile pack-size select — a PROXY over the existing radio pills, not a
  // second control. It never talks to the cart or builds a variant URL itself:
  // it checks the matching radio and re-dispatches a bubbling `change` from it,
  // so native variant-picker.js runs its normal path (fetch → morph →
  // variant:selected / variant:update). Price, availability, ?variant= in the URL,
  // Key Dimensions, Compatibility and the ATC variant id therefore update through
  // exactly the same code as a desktop pill tap.
  if (!window.hhBaseMselBound) {
    window.hhBaseMselBound = true;

    const hhMselReveal = () => {
      document.querySelectorAll('.hh-base-vp-root').forEach((root) => {
        const picker = root.querySelector('variant-picker');
        const wraps = root.querySelectorAll('.hh-base-vp__msel');
        if (!picker || !wraps.length) return;

        let anyReady = false;

        wraps.forEach((wrap) => {
          const select = wrap.querySelector('select[data-hh-msel]');
          if (!select) return;

          // Only enable the swap when EVERY option resolves to a real radio.
          // If the mapping is incomplete the pills stay — never leave the page
          // with a dead control.
          const mapped = Array.from(select.options).every((option) => {
            const id = option.dataset.optionValueId;
            return id && picker.querySelector('input[data-option-value-id="' + id + '"]');
          });
          if (!mapped) return;

          wrap.removeAttribute('hidden');
          anyReady = true;
        });

        if (anyReady) root.classList.add('hh-base-vp-root--msel-on');
      });
    };

    const hhMselInit = () => {
      hhMselReveal();
      // The sync listener above replaces the wrapper's innerHTML on variant:update
      // (fresh <select> node); re-run after it to cover newly injected markup.
      // The [hidden] attribute lives on the wrapper, which survives, so this is a
      // no-op in the common case.
      document.addEventListener('variant:update', () => requestAnimationFrame(hhMselReveal));

      document.addEventListener('change', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLSelectElement) || !target.matches('select[data-hh-msel]')) return;

        const root = target.closest('.hh-base-vp-root');
        const picker = root && root.querySelector('variant-picker');
        if (!picker) return;

        const chosen = target.options[target.selectedIndex];
        const id = chosen && chosen.dataset.optionValueId;
        const radio = id && picker.querySelector('input[data-option-value-id="' + id + '"]');
        if (!radio || radio.checked) return;

        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hhMselInit);
    } else {
      hhMselInit();
    }
  }
  } catch(e) { console.error(e); }
})();

})();
